import { TextField } from '@mui/material';
import React from 'react';

const TextInput = ({ item, onChange }) => {
  const handleChange = (e) => {
    const value = e.target.value;
    if (onChange) {
      onChange(value);
    } else {
      item.answer = value;
    }
  };

  return (
    <div>
      <TextField
        type="text"
        multiline
        rows={3}
        variant="outlined"
        fullWidth
        placeholder="Type your answer here..."
        value={item.answer || ''}
        onChange={handleChange}
        style={{
          maxWidth: '900px',
          margin: '20px 0px 20px 0px'
        }}
        InputProps={{
          style: {
            borderRadius: '10px'
          }
        }}
      />
    </div>
  );
};

export default TextInput;
